module.exports = __webpack_public_path__ + "img/log__circl.0b1efc14.svg";